
export default class InvalidArgumentError extends Error {
    constructor(msg) {
        super(msg);
        this.name = "InvalidArgumentError";
    }
}
